<mg-overlay-primary
  size="auto"
  [isLoading]="(formState$ | async) === 'loading'"
  [overlayTitle]="(isNew$ | async) === true ? MSG.MODAL_TITLE_CREATE : MSG.MODAL_TITLE_EDIT">
  <ng-container>
    <ng-container *ngTemplateOutlet="mainTemplate"></ng-container>
  </ng-container>
  <ng-template #overlayFooter>
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </ng-template>
</mg-overlay-primary>

<!-- Main Template -->
<ng-template #mainTemplate>
  <main class="modal-form tw-flex tw-flex-column tw-gap-4">
    <fieldset *ngIf="(formState$ | async) === 'invalid'">
      <mg-system-alert
        type="error"
        [message]="MSG.RECORD_EDIT_FORM_ERROR">
      </mg-system-alert>
    </fieldset>
    <mg-text
      *ngIf="multipleModulesEnabled$ | async"
      variant="body-sm"
      color="surface-alt">
      {{ MSG.MODAL_HEADER }}
    </mg-text>
    <mg-form-text-input
      label="Name"
      [control]="form.get(FORM_FIELDS.NAME)">
    </mg-form-text-input>
    <fieldset *ngIf="multipleModulesEnabled$ | async">
      <div class="tw-flex tw-flex-column tw-gap-3">
        <div>
          <mg-text variant="body-md">
            {{ MSG.CHECKBOX_SECTION_LABEL }}
          </mg-text>
          <mg-text
            variant="body-xs"
            color="surface-alt">
            {{ MSG.CHECKBOX_SECTION_SECONDARY_LABEL }}
          </mg-text>
        </div>
        <div class="tw-flex tw-items-center tw-gap-2">
          <mg-form-checkbox
            [checked]="isModuleActive(FLAGS.HALL_PASS_ENABLED)"
            (changed)="selectActiveModule($event, FLAGS.HALL_PASS_ENABLED)">
          </mg-form-checkbox>
          <mg-text variant="body-md">
            {{ MSG.HALLPASS_CHECKBOX_LABEL }}
          </mg-text>
        </div>
        <div class="tw-flex tw-items-center tw-gap-2">
          <mg-form-checkbox
            [checked]="isModuleActive(FLAGS.FLEX_TIME_ENABLED)"
            (changed)="selectActiveModule($event, FLAGS.FLEX_TIME_ENABLED)">
          </mg-form-checkbox>
          <mg-text variant="body-md">
            {{ MSG.FLEXTIME_CHECKBOX_LABEL }}
          </mg-text>
        </div>
      </div>
    </fieldset>
  </main>
</ng-template>

<!-- Footer Template -->
<ng-template #footerTemplate>
  <footer class="tw-flex tw-justify-between">
    <mg-btn
      [variant]="(isNew$ | async) ? 'text' : 'destructive'"
      (pressed)="confirmDelete()">
      {{ deleteLabel }}
    </mg-btn>
    <mg-btn
      variant="filled"
      (pressed)="submit()">
      {{ submitLabel }}
    </mg-btn>
  </footer>
</ng-template>
